import { render, staticRenderFns } from "./DeliveryInstructionItemDetail.vue?vue&type=template&id=c025619c&"
import script from "./DeliveryInstructionItemDetail.vue?vue&type=script&lang=js&"
export * from "./DeliveryInstructionItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryInstructionItemDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports